export var FlightDependencyItemLevel;
(function (FlightDependencyItemLevel) {
    FlightDependencyItemLevel[FlightDependencyItemLevel["Info"] = 0] = "Info";
    FlightDependencyItemLevel[FlightDependencyItemLevel["Warning"] = 10] = "Warning";
    FlightDependencyItemLevel[FlightDependencyItemLevel["Blocking"] = 100] = "Blocking";
})(FlightDependencyItemLevel || (FlightDependencyItemLevel = {}));
export var CompositionActionType;
(function (CompositionActionType) {
    CompositionActionType["Remove"] = "Remove";
    CompositionActionType["Undo"] = "Undo";
})(CompositionActionType || (CompositionActionType = {}));
export var CompositionChangeType;
(function (CompositionChangeType) {
    CompositionChangeType["Added"] = "Added";
    CompositionChangeType["Removed"] = "Removed";
    CompositionChangeType["None"] = "None";
})(CompositionChangeType || (CompositionChangeType = {}));
export var FlightCompositionEditResponseItemType;
(function (FlightCompositionEditResponseItemType) {
    FlightCompositionEditResponseItemType["DependencyGraphChanged"] = "DependencyGraphChanged";
    FlightCompositionEditResponseItemType["FlightCompositionContainsCycle"] = "FlightCompositionContainsCycle";
    FlightCompositionEditResponseItemType["RelatedFlight"] = "RelatedFlight";
})(FlightCompositionEditResponseItemType || (FlightCompositionEditResponseItemType = {}));

//# sourceMappingURL=Composition.types.js.map
